export default __webpack_public_path__ + "static/media/icon-website-d.e136c134.svg";